export default __webpack_public_path__ + "static/media/4.6ef2c4d4.jpg";